/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Employee } from 'src/app/_model/employee';

@Injectable()
export abstract class EmployeeDaoService implements Resetable {
  public abstract saveMe(employee: Employee): Promise<void>;
  public abstract saveEmployees(employees: Employee[]): Promise<void>;
  public abstract saveTeam(employees: Employee[]): Promise<void>;
  public abstract getAllEmployees(): Promise<Employee[]>;
  public abstract getMe(): Promise<Employee>;
  public abstract getEmployees(): Promise<Employee[]>;
  public abstract getTeam(): Promise<Employee[]>;
  public abstract addToTeam(employee: Employee): Promise<void>;
  public abstract removeFromTeam(employee: Employee): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
